import { render, staticRenderFns } from "./PriceMgt.vue?vue&type=template&id=5bf4a707&scoped=true&"
import script from "./PriceMgt.vue?vue&type=script&lang=js&"
export * from "./PriceMgt.vue?vue&type=script&lang=js&"
import style0 from "./PriceMgt.vue?vue&type=style&index=0&id=5bf4a707&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf4a707",
  null
  
)

export default component.exports